import * as Dashboard from 'devexpress-dashboard';
import * as Designer from 'devexpress-dashboard/designer';
import * as ko from 'knockout';

import { confirm } from 'devextreme/ui/dialog';
import { ReportDashboardService } from 'app/shared/services/reporting/report-dashboard.service';
import { take } from 'rxjs';

export class DefaultDashboardExtension implements Dashboard.IExtension {
  public name: string;
  private newName: string;
  private menuItem: Designer.DashboardMenuItem;

  constructor(
    private dashboardControl: Dashboard.DashboardControl,
    private reportDashboardService: ReportDashboardService
  ) {
    this.name = 'default-dashboard-extension';

    this.menuItem = new Designer.DashboardMenuItem(
      'default-dashboard',
      'Set as Default Dashboard',
      112,
      0,
      () => {
        this.setAsDefaultDashboard();
      }
    );

    this.menuItem.disabled = ko.computed(() => !dashboardControl.dashboard());
    this.newName = 'Set as Default Dashboard';
  }

  setAsDefaultDashboard() {
    let result = confirm('<b>Set this dashboard as the default dashboard to load?</b>', 'Set Default Dashboard');

    result.then((dialogResult: any) => {
      if (dialogResult) {            
        this.toolboxExtension.menuVisible(false);        
        var dashboardId = this.dashboardControl.dashboardContainer().id;                
        this.reportDashboardService.setAsDefault(dashboardId).pipe(take(1)).subscribe((data) => {});
      }
    });
  }
    
  start() {
    this.toolboxExtension.menuItems.push(this.menuItem);
  }

  stop() {
    this.toolboxExtension.menuItems.remove(this.menuItem);
  }

  private get toolboxExtension(): Designer.ToolboxExtension {
    let extension = this.dashboardControl.findExtension('toolbox');

    if (!extension) {
      throw Error('Default Dashboard Extension requires the Toolbox Extension');
    }

    return <Designer.ToolboxExtension>extension;
  }
  private get newDashboardExtension(): Designer.CreateDashboardExtension {
    let extension = this.dashboardControl.findExtension('create-dashboard');

    if (!extension) {
      throw Error(
        'Default Dashboard Extension requires the Create Dashboard Extension'
      );
    }

    return <Designer.CreateDashboardExtension>extension;
  }
}
